import sharedPropsService, { BUILD_TYPE, getBuildType } from '../SharedPropsService';
import { Platform } from "react-native";
import { StoreKey } from "./api";
import SharedPropsService from "../SharedPropsService";
export const AnalyticsEventTracker = {
    borrower_sign_up: {
        'Event Name': 'borrower_sign_up',
        'Event Type': 'user initiated',
        'Screen Name': 'Email Verification',
        Trigger: 'When user provides email',
        Description: 'New user sign up.',
    },
    borrower_mf_pull: {
        'Event Name': 'borrower_mf_pull',
        'Event Type': 'user initiated',
        'Screen Name': 'MF Fetch',
        Trigger: 'When portfolio is fetched, OTP verification successful and we have some amount',
    },
    borrower_mf_pull_failed: {
        'Event Name': 'borrower_mf_pull_failed',
        'Event Type': 'user initiated',
        'Screen Name': 'MF Fetch',
        Trigger: 'When portfolio is fetched, OTP verification successful and we got empty/null response',
    },
    borrower_mf_pledge_init: {
        'Event Name': 'borrower_mf_pledge_init',
        'Event Type': 'user initiated',
        'Screen Name': 'MF Pledge',
        Trigger: 'When user clicks on initiate pledge request.',
    },
    borrower_mf_pledge_complete: {
        'Event Name': 'borrower_mf_pledge_complete',
        'Event Type': 'user initiated',
        'Screen Name': 'MF Pledge',
        Trigger: 'OTP verification successful and pledge is complete.',
    },
    borrower_ckyc_complete: {
        'Event Name': 'borrower_ckyc_complete',
        'Event Type': 'system initiated',
        'Screen Name': 'KYC Stepper',
        Trigger: 'If CKYC_STEP is complete for the user',
    },
    borrower_kyc_complete: {
        'Event Name': 'borrower_kyc_complete',
        'Event Type': 'user initiated',
        'Screen Name': 'KYC Summary',
        Trigger: 'When user completes the KYC verification and click on KYC succesful modal',
    },
};
export const TextConstants = {
    GENERIC_PROCEED_MESSAGE: 'Please click continue to proceed.',
};
export var QUERY_PARAMS;
(function (QUERY_PARAMS) {
    QUERY_PARAMS["START_NEW"] = "startnew";
    QUERY_PARAMS["PARTNER_PLATFORM"] = "partnerplatform";
    QUERY_PARAMS["PLATFORM"] = "platform";
    QUERY_PARAMS["USER"] = "user";
    QUERY_PARAMS["REF"] = "ref";
    QUERY_PARAMS["PRIMARY_COLOR"] = "primaryColor";
    QUERY_PARAMS["DASHBOARD_ACTIVE_ID"] = "dashboardActiveId";
    QUERY_PARAMS["UID"] = "uid";
    QUERY_PARAMS["RE_DIRECT"] = "redirect";
    QUERY_PARAMS["ROUTE"] = "route";
    QUERY_PARAMS["REFERRED_PARTNER"] = "referredpartner";
    QUERY_PARAMS["TARGET"] = "target";
    QUERY_PARAMS["MARKETING"] = "marketing";
    QUERY_PARAMS["IS_IFRAME"] = "isIframe";
    QUERY_PARAMS["IS_CHECK_LIMIT_MFC"] = "isCheckLimitMFC";
    QUERY_PARAMS["SHORT_LIVED_TOKEN"] = "t";
    QUERY_PARAMS["PLJ"] = "plj";
    QUERY_PARAMS["PARTNER_ACCOUNT_ID"] = "partnerAccountId";
    QUERY_PARAMS["SOURCE"] = "source";
    QUERY_PARAMS["IS_FROM_PARTNER_APP"] = "isFromPartnerApp";
    QUERY_PARAMS["IS_CGTC"] = "isCgtc";
    QUERY_PARAMS["AMPLITUDE_DEVICE_ID"] = "amplitudeDeviceId";
    QUERY_PARAMS["UTM_SOURCE"] = "utm_source";
    QUERY_PARAMS["REQUEST_ID"] = "request_id";
    QUERY_PARAMS["PHONE_PE_FJ"] = "Phonepe_fj";
    QUERY_PARAMS["PLJ_SHORT_TOKEN"] = "plkTK";
    QUERY_PARAMS["SL"] = "sl";
    QUERY_PARAMS["CONTEXT"] = "context";
})(QUERY_PARAMS || (QUERY_PARAMS = {}));
export var ImportScriptSrc;
(function (ImportScriptSrc) {
    ImportScriptSrc["DIGIO_SCRIPT"] = "https://app.digio.in/sdk/v10/digio.js";
})(ImportScriptSrc || (ImportScriptSrc = {}));
export var DigioKycStatus;
(function (DigioKycStatus) {
    DigioKycStatus["CREATED"] = "CREATED";
    DigioKycStatus["COMPLETED"] = "COMPLETED";
    DigioKycStatus["FAILED"] = "FAILED";
    DigioKycStatus["EXPIRED"] = "EXPIRED";
    DigioKycStatus["CANCELLED"] = "CANCELLED";
    DigioKycStatus["SIGNED"] = "SIGNED";
})(DigioKycStatus || (DigioKycStatus = {}));
export var DigioAgreementStatus;
(function (DigioAgreementStatus) {
    DigioAgreementStatus["REQUESTED"] = "REQUESTED";
    DigioAgreementStatus["SIGNED"] = "SIGNED";
    DigioAgreementStatus["EXPIRED"] = "EXPIRED";
    DigioAgreementStatus["CANCELLED"] = "CANCELLED";
})(DigioAgreementStatus || (DigioAgreementStatus = {}));
export var DigioMandateStatus;
(function (DigioMandateStatus) {
    DigioMandateStatus["REQUESTED"] = "REQUESTED";
    DigioMandateStatus["SIGNED"] = "SIGNED";
    DigioMandateStatus["EXPIRED"] = "EXPIRED";
    DigioMandateStatus["COMPLETED"] = "COMPLETED";
})(DigioMandateStatus || (DigioMandateStatus = {}));
export var TATA_MANDATE_STATUS;
(function (TATA_MANDATE_STATUS) {
    TATA_MANDATE_STATUS["FINISHED"] = "Finished";
    TATA_MANDATE_STATUS["IN_PROGRESS"] = "In progress";
})(TATA_MANDATE_STATUS || (TATA_MANDATE_STATUS = {}));
export var DigioDocsStatus;
(function (DigioDocsStatus) {
    DigioDocsStatus["REQUESTED"] = "REQUESTED";
})(DigioDocsStatus || (DigioDocsStatus = {}));
export var POPUP_TARGET_NAME;
(function (POPUP_TARGET_NAME) {
    POPUP_TARGET_NAME["AGREEMENT"] = "volt money";
    POPUP_TARGET_NAME["AUTOPAY"] = "volt money";
})(POPUP_TARGET_NAME || (POPUP_TARGET_NAME = {}));
export var CreditApplicationStepId;
(function (CreditApplicationStepId) {
    CreditApplicationStepId["MF_FETCH_PORTFOLIO"] = "MF_FETCH_PORTFOLIO";
    CreditApplicationStepId["MF_PLEDGE_PORTFOLIO"] = "MF_PLEDGE_PORTFOLIO";
    CreditApplicationStepId["KYC_CKYC"] = "KYC_CKYC";
    CreditApplicationStepId["KYC_AADHAAR_VERIFICATION"] = "KYC_AADHAAR_VERIFICATION";
    CreditApplicationStepId["KYC_DOCUMENT_UPLOAD"] = "KYC_DOCUMENT_UPLOAD";
    CreditApplicationStepId["KYC_DOCUMENT_UPLOAD_POI"] = "KYC_DOCUMENT_UPLOAD_POI";
    CreditApplicationStepId["KYC_DOCUMENT_UPLOAD_POA"] = "KYC_DOCUMENT_UPLOAD_POA";
    CreditApplicationStepId["KYC_PAN_VERIFICATION"] = "KYC_PAN_VERIFICATION";
    CreditApplicationStepId["KYC_PHOTO_VERIFICATION"] = "KYC_PHOTO_VERIFICATION";
    CreditApplicationStepId["KYC_DIGIO_DIGILOCKER"] = "KYC_DIGIO_DIGILOCKER";
    CreditApplicationStepId["DIGIO_AGREEMENT_SIGN"] = "DIGIO_AGREEMENT_SIGN";
    CreditApplicationStepId["DIGIO_MANDATE_SIGN"] = "DIGIO_MANDATE_SIGN";
    CreditApplicationStepId["KYC_SUMMARY"] = "KYC_SUMMARY";
    CreditApplicationStepId["KYC_ADDITIONAL_DETAILS"] = "KYC_ADDITIONAL_DETAILS";
    CreditApplicationStepId["AGREEMENT_SIGN"] = "AGREEMENT_SIGN";
    CreditApplicationStepId["BANK_ACCOUNT_VERIFICATION"] = "BANK_ACCOUNT_VERIFICATION";
    CreditApplicationStepId["MANDATE_SETUP"] = "MANDATE_SETUP";
    CreditApplicationStepId["CREDIT_APPROVAL"] = "CREDIT_APPROVAL";
    CreditApplicationStepId["COMMUNICATION"] = "COMMUNICATION";
    CreditApplicationStepId["KYC_DOCUMENTS"] = "KYC_DOCUMENTS";
    CreditApplicationStepId["CO_BORROWER_PAN_DETAILS"] = "CO_BORROWER_PAN_DETAILS";
    CreditApplicationStepId["CO_BORROWER_CKYC"] = "CO_BORROWER_CKYC";
    CreditApplicationStepId["CO_BORROWER_ADDITIONAL_DETAILS"] = "CO_BORROWER_ADDITIONAL_DETAILS";
    CreditApplicationStepId["CO_BORROWER_POA_DOCUMENT_UPLOAD"] = "CO_BORROWER_POA_DOCUMENT_UPLOAD";
    CreditApplicationStepId["CO_BORROWER_POI_DOCUMENT_UPLOAD"] = "CO_BORROWER_POI_DOCUMENT_UPLOAD";
    CreditApplicationStepId["CO_BORROWER_KYC_SUMMARY"] = "CO_BORROWER_KYC_SUMMARY";
    CreditApplicationStepId["CO_BORROWER_KYC_DOCUMENTS"] = "CO_BORROWER_KYC_DOCUMENTS";
    CreditApplicationStepId["CHECK_CUSTOMER_ELIGIBILITY"] = "CHECK_CUSTOMER_ELIGIBILITY";
    CreditApplicationStepId["TATA_MANDATE"] = "TATA_MANDATE";
    CreditApplicationStepId["CIBIL_CHECK"] = "CIBIL_CHECK";
    CreditApplicationStepId["OFFER_SELECTION"] = "OFFER_SELECTION";
    CreditApplicationStepId["REVIEW_KFS"] = "REVIEW_KFS";
    CreditApplicationStepId["DOCUMENTS"] = "DOCUMENTS";
    CreditApplicationStepId["LOAN_CONTRACT"] = "LOAN_CONTRACT";
})(CreditApplicationStepId || (CreditApplicationStepId = {}));
export const stepIdToNameMap = {
    MF_FETCH_PORTFOLIO: 'Pending MF pull',
    MF_PLEDGE_PORTFOLIO: 'Pending MF pledge',
    KYC_DOCUMENT_UPLOAD_POI: 'MF pledge done, Pending KYC',
    KYC_DOCUMENT_UPLOAD_POA: 'MF pledge done, Pending KYC',
    KYC_PAN_VERIFICATION: 'Pending PAN and other details',
    KYC_SUMMARY: 'MF pledge done, Pending KYC',
    KYC_ADDITIONAL_DETAILS: 'MF pledge done, Pending KYC',
    AGREEMENT_SIGN: 'Pending agreement',
    BANK_ACCOUNT_VERIFICATION: 'Pending bank account verification',
    MANDATE_SETUP: 'Pending autopay setup',
};
export var CreditApplicationState;
(function (CreditApplicationState) {
    CreditApplicationState["IN_PROGRESS"] = "IN_PROGRESS";
    CreditApplicationState["COMPLETED"] = "COMPLETED";
    CreditApplicationState["NOT_STARTED"] = "NOT_STARTED";
})(CreditApplicationState || (CreditApplicationState = {}));
export const PartnerLink = getBuildType() === BUILD_TYPE.PARTNER_PRODUCTION ||
    getBuildType() === BUILD_TYPE.BORROWER_PRODUCTION
    ? 'https://voltmoney.in/partner'
    : 'https://staging.voltmoney.in/partner';
export const SignDeskSDKUrl = getBuildType() === BUILD_TYPE.BORROWER_PRODUCTION
    ? 'https://signdesk.in/api/eSignWidgetLive.js'
    : 'https://signdesk.in/api/eSignWidgetUat.js';
export const InviteAndEarnLink = getBuildType() === BUILD_TYPE.PARTNER_PRODUCTION ||
    getBuildType() === BUILD_TYPE.BORROWER_PRODUCTION
    ? 'https://voltmoney.in/invite-and-earn'
    : 'https://staging.voltmoney.in/invite-and-earn';
export const VoltWebSiteBaseLink = getBuildType() === BUILD_TYPE.PARTNER_PRODUCTION ||
    getBuildType() === BUILD_TYPE.BORROWER_PRODUCTION
    ? 'https://voltmoney.in/'
    : 'https://staging.voltmoney.in/';
export const getAppLinkOnBuildType = () => {
    const buildType = getBuildType();
    switch (buildType) {
        case BUILD_TYPE.BORROWER_PRODUCTION:
            return 'https://app.voltmoney.in/';
        case BUILD_TYPE.PARTNER_PRODUCTION:
            return 'https://app.voltmoney.in/';
        case BUILD_TYPE.BORROWER_TEST_STAGING:
            return 'https://test.staging.voltmoney.in/';
        default:
            return 'https://qa.staging.voltmoney.in/';
    }
};
export const AppLink = getAppLinkOnBuildType();
export const PARTNER_CACHE_EXPIRE_TIME = 1;
export var PartnerAccountType;
(function (PartnerAccountType) {
    PartnerAccountType["INDIVIDUAL"] = "INDIVIDUAL";
    PartnerAccountType["ORGANISATION"] = "ORGANISATION";
    PartnerAccountType["EXTERNAL_MARKETING"] = "EXTERNAL_MARKETING";
    PartnerAccountType["AFFILIATE"] = "AFFILIATE";
})(PartnerAccountType || (PartnerAccountType = {}));
export var DashboardActiveId;
(function (DashboardActiveId) {
    DashboardActiveId["LEAD_PAGE"] = "leadPage";
    DashboardActiveId["ACTIVE_CUSTOMER"] = "activeCustomerPage";
    DashboardActiveId["REFERRED_PARTNER"] = "referredPartnerPage";
})(DashboardActiveId || (DashboardActiveId = {}));
export const PARTNER_BASE = 'partner';
export const ROUTE_PARTNER = {
    SIGNUP: 'signup',
    DASHBOARD: 'dashboard',
    PARTNER: 'partner',
    FAQ: 'faq',
    DASHBOARD_NEW: 'dashboard_new',
    LEADS: 'leads',
    ACTIVE_CUSTOMER: 'customer',
    REFERRED_PARTNER: 'referredpartner',
    COLLATERAL: 'collateral',
    DEMO_VIDEOS: 'demo_videos',
    MY_ACCOUNT: 'my_account',
    CHECK_LIMIT: 'free-eligibility-check',
    EARNING: 'earning',
    AFFILIATE_SIGNUP: 'affiliate_signup',
    AUTH: 'auth',
    VIEW_CUSTOMER_PORTFOLIO: 'view-customer-portfolio',
    CAPITAL_GAIN: 'capitalGain'
};
export var CACHE_KEY;
(function (CACHE_KEY) {
    CACHE_KEY["LEADS"] = "LEADS";
    CACHE_KEY["ACTIVE_CUSTOMER"] = "ACTIVE_CUSTOMER";
    CACHE_KEY["REFERRED_PARTNER"] = "REFERRED_PARTNER";
})(CACHE_KEY || (CACHE_KEY = {}));
export var TARGET_PAGES;
(function (TARGET_PAGES) {
    TARGET_PAGES["MANAGE_LIMIT"] = "manageLimit";
    TARGET_PAGES["ACCOUNT"] = "account";
    TARGET_PAGES["REPAYMENT"] = "payment";
    TARGET_PAGES["WITHDRAW"] = "withdraw";
    TARGET_PAGES["FORECLOSURE"] = "foreclosure";
    TARGET_PAGES["TRANSACTION"] = "transaction";
})(TARGET_PAGES || (TARGET_PAGES = {}));
export const getInterestRate = () => {
    let interestRate = 9.99;
    if (Platform.OS === 'web') {
        const userFromLocalStorage = localStorage.getItem(StoreKey.userContext);
        if (userFromLocalStorage && userFromLocalStorage !== 'undefined') {
            const _user = JSON.parse(localStorage.getItem(StoreKey.userContext));
            const partnerAccountType = _user?.linkedPartnerAccounts[0]?.partnerAccountType;
            if (partnerAccountType === PartnerAccountType.AFFILIATE) {
                interestRate = 10.49;
            }
        }
    }
    return `${interestRate}% p.a`;
};
export const InterestRate = getInterestRate();
export const partnerHelpLineNumber = '9611749295';
export const partnerAffiliateHelpLineNumber = '9611749041';
export const SDKInvestwellPartnerHelpLineNumber = '7795402425';
export var Links;
(function (Links) {
    Links["BAJAJ"] = "https://www.bajajfinserv.in/";
    Links["KFIN"] = "https://www.kfintech.com/";
    Links["CAMS"] = "https://www.camsonline.com/";
    Links["NSDL"] = "https://nsdl.co.in/";
    Links["CDSL"] = "https://www.cdslindia.com/";
    Links["VOLT_PRIVACY"] = "https://voltmoney.in/privacy/";
})(Links || (Links = {}));
export const UTM_expiry_days = 28;
export const PartnerFaqLink = `${PartnerLink}/faq/`;
export const WhatsAppLink = {
    help: `https://wa.me/91${partnerHelpLineNumber}`,
    helpPartner: `https://api.whatsapp.com/send?phone=91${partnerHelpLineNumber}`,
    helpPartnerSDK_INVESTWELL: `https://api.whatsapp.com/send?phone=91${SDKInvestwellPartnerHelpLineNumber}`,
};
export var GoogleUtmParams;
(function (GoogleUtmParams) {
    GoogleUtmParams["UTM_CAMPAIGN"] = "utm_campaign";
    GoogleUtmParams["UTM_CONTENT"] = "utm_content";
    GoogleUtmParams["UTM_ID"] = "utm_id";
    GoogleUtmParams["UTM_MEDIUM"] = "utm_medium";
    GoogleUtmParams["UTM_SOURCE"] = "utm_source";
    GoogleUtmParams["UTM_TERM"] = "utm_term";
})(GoogleUtmParams || (GoogleUtmParams = {}));
export const minAllowedCreditLimit = 25000;
export var PortfolioType;
(function (PortfolioType) {
    PortfolioType["ELIGIBLE"] = "ELIGIBLE";
    PortfolioType["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
})(PortfolioType || (PortfolioType = {}));
export var NonEligiblePortfolioType;
(function (NonEligiblePortfolioType) {
    NonEligiblePortfolioType["LOCKED"] = "LOCKED";
    NonEligiblePortfolioType["UNAPPROVED"] = "UNAPPROVED";
    NonEligiblePortfolioType["DEMAT"] = "DEMAT";
    NonEligiblePortfolioType["JOINT_HOLDER"] = "JOINT_HOLDER";
})(NonEligiblePortfolioType || (NonEligiblePortfolioType = {}));
export var CheckLimitInfoType;
(function (CheckLimitInfoType) {
    CheckLimitInfoType["TOTAL_AVAILABLE_LIMIT"] = "TOTAL_AVAILABLE_LIMIT";
    CheckLimitInfoType["LOCKED"] = "LOCKED";
    CheckLimitInfoType["UNAPPROVED"] = "UNAPPROVED";
    CheckLimitInfoType["DEMAT"] = "DEMAT";
    CheckLimitInfoType["JOINT_HOLDER"] = "JOINT_HOLDER";
})(CheckLimitInfoType || (CheckLimitInfoType = {}));
export var PLATFORM_CODE;
(function (PLATFORM_CODE) {
    PLATFORM_CODE["SDK_INVESTWELL"] = "SDK_INVESTWELL";
    PLATFORM_CODE["VOLT_WEB_APP"] = "VOLT_WEB_APP";
    PLATFORM_CODE["VOLT_MOBILE_APP"] = "VOLT_MOBILE_APP";
    PLATFORM_CODE["IIFL"] = "IIFL";
    PLATFORM_CODE["VOLT_PARTNER_ANDROID_APP"] = "VOLT_PARTNER_ANDROID_APP";
    PLATFORM_CODE["PHONEPE"] = "PHONEPE";
})(PLATFORM_CODE || (PLATFORM_CODE = {}));
export var CONTEXT;
(function (CONTEXT) {
    CONTEXT["PARTNER"] = "PARTNER";
    CONTEXT["VIEW_DETAIL"] = "VIEW_DETAIL";
})(CONTEXT || (CONTEXT = {}));
export const PARTNER_HEADER_HEIGHT = 60;
export const PARTNER_FOOTER_HEIGHT = 64;
export var APPLICATION_STATE;
(function (APPLICATION_STATE) {
    APPLICATION_STATE["COMPLETED"] = "COMPLETED";
    APPLICATION_STATE["IN_PROGRESS"] = "IN_PROGRESS";
    APPLICATION_STATE["NOT_STARTED"] = "NOT_STARTED";
    APPLICATION_STATE["BLOCKED"] = "BLOCKED";
    APPLICATION_STATE["DENIED"] = "DENIED";
})(APPLICATION_STATE || (APPLICATION_STATE = {}));
export var LENDER_ID;
(function (LENDER_ID) {
    LENDER_ID["TATA"] = "tata";
    LENDER_ID["MIRAE"] = "mirae";
    LENDER_ID["BAJAJ"] = "bajaj";
    LENDER_ID["NUVAMA"] = "nuvama";
    LENDER_ID["DSP"] = "dsp";
})(LENDER_ID || (LENDER_ID = {}));
export var DemoVideosLink;
(function (DemoVideosLink) {
    DemoVideosLink["DEFAULT"] = "https://api.staging.voltmoney.in/util/web/static/data?pageId=partnerDemoVideos";
    DemoVideosLink["AFFILIATE"] = "https://api.staging.voltmoney.in/util/web/static/data?pageId=affiliateDemoVideos";
})(DemoVideosLink || (DemoVideosLink = {}));
export var PARTNER_REFCODE;
(function (PARTNER_REFCODE) {
    PARTNER_REFCODE["LLA"] = "5RXOYK";
})(PARTNER_REFCODE || (PARTNER_REFCODE = {}));
export var VOLT_ERROR_CODE;
(function (VOLT_ERROR_CODE) {
    VOLT_ERROR_CODE["BAD_REQUEST_PHOTO_MISMATCH"] = "BAD_REQUEST_PHOTO_MISMATCH";
    VOLT_ERROR_CODE["DIGIO_PAN_MISMATCH"] = "DIGIO_PAN_MISMATCH";
    VOLT_ERROR_CODE["BAD_REQUEST_INVALID_INPUT"] = "BAD_REQUEST_INVALID_INPUT";
    VOLT_ERROR_CODE["PORTFOLIO_RESPONSE_PENDING"] = "PORTFOLIO_RESPONSE_PENDING";
    VOLT_ERROR_CODE["PORTFOLIO_NOT_FOUND"] = "PORTFOLIO_NOT_FOUND";
    VOLT_ERROR_CODE["KYC_VERIFICATION_FAILED_NAME_MISMATCH_DIGIO"] = "KYC_VERIFICATION_FAILED_NAME_MISMATCH_DIGIO";
    VOLT_ERROR_CODE["NAME_MISMATCH"] = "NAME_MISMATCH";
    VOLT_ERROR_CODE["ADDRESS_MISMATCH"] = "ADDRESS_MISMATCH";
    VOLT_ERROR_CODE["USER_AUTH_CANCELLED"] = "USER_AUTH_CANCELLED";
    VOLT_ERROR_CODE["USER_CONSENT_DENIED"] = "USER_CONSENT_DENIED";
    VOLT_ERROR_CODE["KYC_NOT_INITIATED"] = "KYC_NOT_INITIATED";
    VOLT_ERROR_CODE["INSUFFICIENT_SCOPE"] = "INSUFFICIENT_SCOPE";
    VOLT_ERROR_CODE["PAN_AADHAAR_NOT_LINKED"] = "PAN_AADHAAR_NOT_LINKED";
    VOLT_ERROR_CODE["INVALID_PAN"] = "INVALID_PAN";
    VOLT_ERROR_CODE["UNEXPECTED_ERROR"] = "UNEXPECTED_ERROR";
    VOLT_ERROR_CODE["PAN_NOT_SEEDED"] = "PAN_NOT_SEEDED";
    VOLT_ERROR_CODE["MISMATCH_DETECTED"] = "MISMATCH_DETECTED";
    VOLT_ERROR_CODE["AGE_BELOW_LIMIT"] = "AGE_BELOW_LIMIT";
    VOLT_ERROR_CODE["AGE_ABOVE_LIMIT"] = "AGE_ABOVE_LIMIT";
})(VOLT_ERROR_CODE || (VOLT_ERROR_CODE = {}));
export const LOAN_RENEWAL_FLOW_SHOW = async () => {
    const user = await sharedPropsService.getUser();
    const userPhoneNumber = user?.user?.phoneNumber;
    const test_numbers_renewal = await sharedPropsService.getFirebaseConfig()?.test_numbers_renewal;
    if (!test_numbers_renewal)
        return false;
    const test_numbers_renewal_object = JSON.parse(test_numbers_renewal);
    const loan_renewal_test_phoneNumbers = test_numbers_renewal_object?.numbers
        ? test_numbers_renewal_object?.numbers
        : [];
    const loanRenewalFlowFlag = await sharedPropsService.getFirebaseConfig()?.loan_renewal_feature_enabled;
    const loanRenewalFlowFlagTata = await sharedPropsService.getFirebaseConfig()?.loan_renewal_feature_enabled_tata;
    const lenderId = user?.linkedCredits[0]?.lendingPartnerId;
    if (lenderId?.toLowerCase() === LENDER_ID.TATA) {
        if (loanRenewalFlowFlagTata &&
            (loanRenewalFlowFlagTata === true ||
                loanRenewalFlowFlagTata === "true")) {
            return true;
        }
        else {
            return loan_renewal_test_phoneNumbers?.includes(userPhoneNumber?.slice(3));
        }
    }
    else {
        if (loanRenewalFlowFlag ||
            loan_renewal_test_phoneNumbers?.includes(userPhoneNumber.slice(3))) {
            return true;
        }
        else {
            return false;
        }
    }
};
export const LOAN_RENEWAL_ALLOW_ADMIN = async () => {
    const user = await sharedPropsService.getUser();
    const userPhoneNumber = user?.user?.phoneNumber;
    const test_numbers_renewal = await sharedPropsService.getFirebaseConfig()?.loan_renewal_admin_allow_test_numbers;
    if (!test_numbers_renewal)
        return false;
    const test_numbers_renewal_object = JSON.parse(test_numbers_renewal);
    const loan_renewal_test_phoneNumbers = test_numbers_renewal_object?.numbers
        ? test_numbers_renewal_object?.numbers
        : [];
    if (loan_renewal_test_phoneNumbers?.includes(userPhoneNumber.slice(3))) {
        return true;
    }
    else {
        return false;
    }
};
export const foreclosureTrackingFlag = async () => {
    const user = await sharedPropsService.getUser();
    const userPhoneNumber = user?.user?.phoneNumber;
    const foreclosure_tracking_fb = await sharedPropsService.getFirebaseConfig()?.foreclosure_tracking_numbers;
    const foreclosure_tracking_flag = await SharedPropsService.getFirebaseConfig()?.foreclosure_tracking_flag;
    if (!foreclosure_tracking_fb)
        return false;
    const foreclosure_tracking_numbers_object = JSON.parse(foreclosure_tracking_fb);
    const foreclosure_tracking_numbers = foreclosure_tracking_numbers_object?.numbers
        ? foreclosure_tracking_numbers_object?.numbers
        : [];
    if (foreclosure_tracking_flag &&
        (foreclosure_tracking_flag === true ||
            foreclosure_tracking_flag === 'true')) {
        return true;
    }
    else {
        return foreclosure_tracking_numbers?.includes(userPhoneNumber.slice(3));
    }
};
export var REPAYMENT_COLLECTION_TYPE;
(function (REPAYMENT_COLLECTION_TYPE) {
    REPAYMENT_COLLECTION_TYPE["LOAN_EXPIRED_DUE_REPAYMENT"] = "LOAN_EXPIRED_DUE_REPAYMENT";
    REPAYMENT_COLLECTION_TYPE["PRINCIPAL_REPAYMENT"] = "PRINCIPAL_REPAYMENT";
    REPAYMENT_COLLECTION_TYPE["IN_APP_INTEREST_COLLECTION"] = "IN_APP_INTEREST_COLLECTION";
    REPAYMENT_COLLECTION_TYPE["SHORTFALL_REPAYMENT"] = "SHORTFALL_REPAYMENT";
    REPAYMENT_COLLECTION_TYPE["FORECLOSURE"] = "FORECLOSURE";
})(REPAYMENT_COLLECTION_TYPE || (REPAYMENT_COLLECTION_TYPE = {}));
export var AMPLITUDE_EVENT;
(function (AMPLITUDE_EVENT) {
    AMPLITUDE_EVENT["CONTACT_SUPPORT_BUTTON_CLICKED"] = "CONTACT_SUPPORT_BUTTON_CLICKED";
    AMPLITUDE_EVENT["CONTACT_VIA_WA_BUTTON_CLICKED"] = "CONTACT_VIA_WA_BUTTON_CLICKED";
    AMPLITUDE_EVENT["CONTACT_VIA_CALL_BUTTON_CLICKED"] = "CONTACT_VIA_CALL_BUTTON_CLICKED";
    AMPLITUDE_EVENT["CONTACT_VIA_EMAIL_BUTTON_CLICKED"] = "CONTACT_VIA_EMAIL_BUTTON_CLICKED";
})(AMPLITUDE_EVENT || (AMPLITUDE_EVENT = {}));
export var AMPLITUDE_EVENT_PROPERTY;
(function (AMPLITUDE_EVENT_PROPERTY) {
    AMPLITUDE_EVENT_PROPERTY["CURRENT_SCREEN"] = "current_screen";
})(AMPLITUDE_EVENT_PROPERTY || (AMPLITUDE_EVENT_PROPERTY = {}));
export const MIN_LIMIT = {
    'ENHANCE_LIMIT': 25000
};
export var CREDIT_STATUS;
(function (CREDIT_STATUS) {
    CREDIT_STATUS["REQUESTED"] = "REQUESTED";
    CREDIT_STATUS["APPROVED_APPLICATION_PENDING"] = "APPROVED_APPLICATION_PENDING";
    CREDIT_STATUS["PENDING_DISBURSAL_APPROVAL"] = "PENDING_DISBURSAL_APPROVAL";
    CREDIT_STATUS["PENDING_LODGEMENT"] = "PENDING_LODGEMENT";
    CREDIT_STATUS["APPROVED_NOT_DISBURSED"] = "APPROVED_NOT_DISBURSED";
    CREDIT_STATUS["ACTIVE"] = "ACTIVE";
    CREDIT_STATUS["PENDING_CLOSURE"] = "PENDING_CLOSURE";
    CREDIT_STATUS["CLOSED"] = "CLOSED";
})(CREDIT_STATUS || (CREDIT_STATUS = {}));
export var UPDATE_REQUEST_TYPE;
(function (UPDATE_REQUEST_TYPE) {
    UPDATE_REQUEST_TYPE["PHONE_NUMBER"] = "PHONE_NUMBER";
    UPDATE_REQUEST_TYPE["EMAIL"] = "EMAIL";
})(UPDATE_REQUEST_TYPE || (UPDATE_REQUEST_TYPE = {}));
export var UPDATE_STATUS_TYPE;
(function (UPDATE_STATUS_TYPE) {
    UPDATE_STATUS_TYPE["REQUESTED"] = "REQUESTED";
    UPDATE_STATUS_TYPE["SUCCESS"] = "SUCCESS";
    UPDATE_STATUS_TYPE["REJECTED"] = "REJECTED";
    UPDATE_STATUS_TYPE["FAILURE"] = "FAILURE";
})(UPDATE_STATUS_TYPE || (UPDATE_STATUS_TYPE = {}));
